module.exports = __webpack_public_path__ + "static/media/youtube.812e34ca.svg";